import { createAction } from '@reduxjs/toolkit';

export interface UpdateCartItemPayload {
    productId: string;
    variantId?: string;
    quantity: number;
}

export const updateCartItem = createAction<UpdateCartItemPayload>('items/updateCartItem');
